module.exports = __webpack_public_path__ + "img/logo-storebuilder.8706080b.svg";